import React, { useEffect, useState } from "react";
import { GelfServiceReporter } from "@web/decorators/lib/decorators/tracer/reporters/GelfServiceReporter";
import Routes from "./Routes";
import { ProviderWrapper } from "./common";
import { DomestikaProvider } from "./DomestikaContext";
import { contextFactory } from "./context";
import { getLang } from "../js/utils/functions";
import When from "./common/When";

if (window.ENV.GELF_SERVICE_URL) {
  window.__DOMESTIKA_DECORATOR_TRACER_REPORTER__ = GelfServiceReporter.create({
    service: window.ENV.GELF_SERVICE_URL.replace(/\/$/, ""),
  });
}

const AppRequest = (props) => {
  const [context, setContext] = useState();

  const createContext = async () => {
    const { domain } = await contextFactory({ language: getLang });
    if (window.location.pathname.match(/^\/[a-zA-Z]{2}\/?$|my_courses|live/)) {
      await domain.CurrentWithoutRelationshipsUserUseCase.execute();
    }
    setContext(domain);
  };

  useEffect(() => {
    createContext();
  }, []);

  return (
    <When condition={!!context}>
      {() => (
        <DomestikaProvider value={context}>
          <ProviderWrapper>
            {/* eslint-disable-next-line react/jsx-props-no-spreading */}
            <Routes {...props} />
          </ProviderWrapper>
        </DomestikaProvider>
      )}
    </When>
  );
};

export default AppRequest;
